(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["footer-menu"] && !Shopify.designMode) return;
  try {
    // Once a <li>'s animation has finished, the browser considers it "at
  // rest" and won't replay the same keyframes just because [open] is
  // toggled off and back on - only the very first open actually played.
  // AccordionDetails dispatches its own "toggle" CustomEvent (bubbles)
  // whenever a footer-details element's open state changes; on open,
  // force each row's animation to restart by clearing it, forcing a
  // reflow, then restoring it.
  (function () {
    if (window.__footerMenuAnimBound) return;
    window.__footerMenuAnimBound = true;
    // The row animation above only exists under body.loaded at
    // screen and (max-width: 767px); outside that there is nothing to
    // restart, so the forced reflow below is skipped. This covers the
    // accordions FooterDetails opens while theme.js upgrades them (before
    // body.loaded) and every open on wider viewports.
    var footerMenuAnimQuery = window.matchMedia('screen and (max-width: 767px)');

    document.addEventListener('toggle', function (event) {
      var details = event.target;
      if (!details || !details.matches || !details.matches('details[is="footer-details"]')) return;
      if (!event.detail || !event.detail.open) return;
      if (!document.body.classList.contains('loaded') || !footerMenuAnimQuery.matches) return;

      var items = details.querySelectorAll('.details__content li');
      if (!items.length) return;

      // A separate forced reflow per <li> was blocking the main thread
      // right as the accordion's own open transition (height/opacity via
      // Motion, plus the chevron's CSS rotate) started, causing visible
      // jank on the chevron icon. One reflow for the whole batch is
      // enough to flush the "none" state before restoring it.
      items.forEach(function (item) {
        item.style.animation = 'none';
      });
      void details.offsetWidth;
      items.forEach(function (item) {
        item.style.animation = '';
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["glass-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('glass-localization')) {
    customElements.define('glass-localization', class extends HTMLElement {
      connectedCallback() {
        if (this.controller || !('showPopover' in HTMLElement.prototype)) return;
        this.form = this.querySelector('form');
        this.select = this.querySelector('[data-select]');
        this.trigger = this.querySelector('[data-trigger]');
        this.menu = this.querySelector('[data-menu]');
        this.list = this.querySelector('[data-list]');
        this.search = this.querySelector('[data-search]');
        this.empty = this.querySelector('[data-empty]');
        if (!this.form || !this.select || !this.trigger || !this.menu || !this.list) return;

        this.restoreServerSelection();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        if (this.items?.length && this.itemsSelect === this.select && this.items[0].parentNode === this.list) {
          // Re-connected after the menu drawer moved to/from <body>: keep the rows and
          // reset them to their freshly built state (syncSelection rewrites aria-selected).
          this.items.forEach((item) => {
            item.hidden = false;
            item.removeAttribute('data-active');
            // (and without the marks the skin gives the rows in view while
            // the menu is open - assets/premiere-locale.js, data-stagger)
            item.removeAttribute('data-stagger');
            item.style.removeProperty('--row-i');
            if (!item.getAttribute('style')) item.removeAttribute('style');
          });
        } else {
          // The rows sit in the closed (display: none) popover, so they are built on
          // first use (ensureItems) instead of for every selector on every page load.
          this.items = [];
          this.itemsSelect = null;
        }
        this.syncSelection();
        this.querySelector('[data-fallback]').hidden = true;
        this.trigger.hidden = false;

        this.trigger.addEventListener('pointerdown', event => {
          // Build the rows on press, before the click that opens the menu.
          this.ensureItems();
          if (event.button !== 0 || event.isPrimary === false) return;
          this.triggerPress = { wasOpen: this.isOpen };
        }, options);
        document.addEventListener('pointercancel', () => {
          this.triggerPress = null;
        }, options);
        document.addEventListener('pointerdown', event => {
          if (!this.trigger.contains(event.target)) this.triggerPress = null;
          const compactViewport = window.matchMedia('(max-width: 1023px)').matches;
          if (compactViewport && this.isOpen && !this.contains(event.target)) this.close(false);
        }, { ...options, capture: true });
        this.trigger.addEventListener('click', event => {
          event.preventDefault();
          const wasOpen = event.detail > 0 && this.triggerPress ? this.triggerPress.wasOpen : this.isOpen;
          this.triggerPress = null;
          wasOpen ? this.close() : this.open();
        }, options);
        this.trigger.addEventListener('keydown', event => {
          this.triggerPress = null;
          if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
          event.preventDefault();
          this.open();
        }, options);
        this.list.addEventListener('click', event => {
          const item = event.target.closest('[role="option"]');
          if (item) this.choose(Number(item.dataset.index));
        }, options);
        this.list.addEventListener('keydown', event => this.onKeyDown(event), options);
        this.search?.addEventListener('input', () => {
          this.filter();
          if (this.isOpen) this.reflowMenu();
        }, options);
        this.search?.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
            return;
          }
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            this.list.focus({ preventScroll: true });
            this.onKeyDown(event);
            return;
          }
          if (event.key === 'Enter') {
            event.preventDefault();
            if (this.activeIndex >= 0 && !this.items[this.activeIndex]?.hidden) this.choose(this.activeIndex);
          }
        }, options);
        this.menu.addEventListener('beforetoggle', event => {
          this.isOpen = event.newState === 'open';
          this.trigger.setAttribute('aria-expanded', String(this.isOpen));
          if (!this.isOpen) this.searchText = '';
        }, options);
        this.select.addEventListener('change', () => this.syncSelection(), options);
        document.addEventListener('glass-localization:change', event => {
          if (event.detail?.kind !== this.dataset.kind) return;
          const index = Array.from(this.select.options).findIndex(option => option.value === event.detail.value);
          if (index < 0) return;
          this.select.selectedIndex = index;
          this.syncSelection();
        }, options);

        // A pointer press on a non-focusable listbox option temporarily moves
        // focus to the document body before its click event fires. Without
        // tracking that press, focusout closes the popover and removes the
        // option before the click handler can select it.
        this.menu.addEventListener('pointerdown', event => {
          if (event.button !== 0 || event.isPrimary === false) return;
          this.menuPointerActive = true;
          const item = event.target.closest('[role="option"]');
          this.optionPointer = item ? {
            item,
            pointerId: event.pointerId,
            x: event.clientX,
            y: event.clientY
          } : null;
        }, options);
        this.menu.addEventListener('pointerup', event => {
          const press = this.optionPointer;
          this.optionPointer = null;
          if (!press || press.pointerId !== event.pointerId) return;
          const item = event.target.closest('[role="option"]');
          const moved = Math.hypot(event.clientX - press.x, event.clientY - press.y);
          if (item === press.item && moved < 8) {
            event.preventDefault();
            this.choose(Number(item.dataset.index));
          }
        }, options);
        const endMenuPointer = () => {
          this.menuPointerActive = false;
          this.optionPointer = null;
        };
        document.addEventListener('pointerup', endMenuPointer, options);
        document.addEventListener('pointercancel', endMenuPointer, options);

        this.addEventListener('focusout', () => {
          if (window.matchMedia('(max-width: 1023px)').matches) return;
          queueMicrotask(() => {
            if (this.menuPointerActive) return;
            if (this.isOpen && !this.contains(document.activeElement)) this.close(false);
          });
        }, options);
        const reposition = event => {
          // Closed (nearly always): return before building a MediaQueryList.
          // This runs, in every instance on the page, for each scroll event in
          // the document (capture) and each window/visualViewport resize and
          // visualViewport scroll - e.g. every mobile URL-bar show/hide. The
          // reads skipped here (matchMedia().matches, document.activeElement)
          // have no side effects, and a closed menu returned on the next line
          // whatever they gave; the open path below is unchanged.
          if (!this.isOpen) return;
          const compactSearchActive = window.matchMedia('(max-width: 1023px)').matches && document.activeElement === this.search;
          // (resize and visualViewport events target the window or the
          // visualViewport, not a Node: contains() threw on them, so an open
          // menu never followed a resize)
          if (!this.isOpen || (event.target instanceof Node && this.menu.contains(event.target)) || this.frame || compactSearchActive) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.positionMenu();
          });
        };
        window.addEventListener('resize', reposition, options);
        document.addEventListener('scroll', reposition, { ...options, capture: true, passive: true });
        window.visualViewport?.addEventListener('resize', reposition, options);
        window.visualViewport?.addEventListener('scroll', reposition, options);
        window.addEventListener('pageshow', () => {
          this.submitting = false;
          this.trigger.removeAttribute('aria-busy');
          this.close(false);
          this.restoreServerSelection();
          this.syncSelection();
        }, options);
      }

      disconnectedCallback() {
        if (!this.controller) return;
        this.closing?.cancel();
        this.closing = null;
        if (this.menu?.matches(':popover-open')) this.menu.hidePopover();
        this.isOpen = false;
        this.triggerPress = null;
        this.controller?.abort();
        this.controller = null;
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      ensureItems() {
        if (this.itemsSelect === this.select) return;
        this.items = Array.from(this.select.options, (option, index) => {
          const item = document.createElement('div');
          item.className = 'glass-localization__option';
          item.id = `${this.list.id}-${index}`;
          item.setAttribute('role', 'option');
          item.setAttribute('aria-selected', String(option.selected));
          if (option.disabled) item.setAttribute('aria-disabled', 'true');
          if (option.lang) item.lang = option.lang;
          item.dataset.index = index;
          const label = option.textContent.trim();
          item.dataset.label = label;
          // (data-search-text: [data-search] marks the search input, and a selector
          // without one - language - used to pick up its first row as the input
          // once reconnected, so open() "focused" that row instead of the list)
          item.dataset.searchText = option.dataset.name ? `${label} ${option.dataset.name}` : label;
          if (this.dataset.kind === 'language') {
            const flag = document.createElement('span');
            flag.className = 'glass-localization__flag';
            flag.setAttribute('aria-hidden', 'true');
            flag.textContent = this.languageFlag(option.value);
            const text = document.createElement('span');
            text.className = 'glass-localization__option-label';
            text.textContent = label;
            item.replaceChildren(flag, text);
          } else {
            item.textContent = label;
          }
          return item;
        });
        this.itemsSelect = this.select;
        this.list.replaceChildren(...this.items);
      }

      persistedSelection() {
        if (this.dataset.kind !== 'country' || !window.matchMedia('(max-width: 1023px)').matches) return '';
        try {
          return window.sessionStorage.getItem('glass-localization:country') || '';
        } catch (error) {
          return '';
        }
      }

      persistSelection(value) {
        if (this.dataset.kind !== 'country' || !window.matchMedia('(max-width: 1023px)').matches) return;
        try {
          window.sessionStorage.setItem('glass-localization:country', value);
        } catch (error) {
        }
      }

      restoreServerSelection() {
        const currentValue = this.persistedSelection() || this.dataset.currentValue;
        if (!currentValue) return;
        const index = Array.from(this.select.options).findIndex(option => option.value === currentValue);
        if (index >= 0) this.select.selectedIndex = index;
      }

      languageFlag(locale) {
        const normalized = String(locale || '').replace('_', '-');
        const parts = normalized.split('-');
        const language = parts[0].toLowerCase();
        const explicitRegion = parts.slice(1).find(part => /^[a-z]{2}$/i.test(part));
        const fallbackRegions = {
          ar: 'SA', cs: 'CZ', da: 'DK', de: 'DE', el: 'GR', en: 'GB', es: 'ES',
          fi: 'FI', fr: 'FR', he: 'IL', hi: 'IN', hu: 'HU', id: 'ID', it: 'IT',
          ja: 'JP', ko: 'KR', ms: 'MY', nb: 'NO', nl: 'NL', no: 'NO', pl: 'PL',
          pt: 'PT', ro: 'RO', ru: 'RU', sk: 'SK', sv: 'SE', th: 'TH', tr: 'TR',
          uk: 'UA', vi: 'VN', zh: 'CN'
        };
        let region = explicitRegion?.toUpperCase() || fallbackRegions[language];
        if (!region && typeof Intl.Locale === 'function') {
          try {
            region = new Intl.Locale(normalized).maximize().region;
          } catch (error) {
            region = '';
          }
        }
        if (!/^[A-Z]{2}$/.test(region || '')) return '🌐';
        return String.fromCodePoint(...Array.from(region, character => character.charCodeAt(0) + 127397));
      }

      syncSelection() {
        const selected = this.select.selectedIndex;
        const selectedOption = this.select.options[selected];
        this.querySelector('[data-value]').textContent = selectedOption?.textContent.trim() || '';
        const selectedFlag = this.querySelector('[data-selected-flag]');
        if (selectedFlag) selectedFlag.textContent = this.languageFlag(selectedOption?.value);
        this.items.forEach((item, index) => item.setAttribute('aria-selected', String(index === selected)));
      }

      normalizeText(text) {
        return String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
      }

      filter() {
        if (!this.search) return;
        const query = this.normalizeText(this.search.value.trim());
        let firstVisible = -1;
        this.items.forEach((item, index) => {
          const matches = !query || this.normalizeText(item.dataset.searchText).includes(query);
          item.hidden = !matches;
          if (matches && firstVisible === -1) firstVisible = index;
        });
        this.list.scrollTop = 0;
        if (this.empty) this.empty.hidden = firstVisible !== -1;
        if (firstVisible === -1) {
          this.activeIndex = -1;
          this.list.removeAttribute('aria-activedescendant');
        } else {
          this.activate(firstVisible);
        }
      }

      nextVisible(from, direction, steps = 1) {
        let index = from;
        let result = from;
        for (let taken = 0; taken < steps; taken++) {
          let candidate = index + direction;
          while (candidate >= 0 && candidate < this.items.length && this.items[candidate].hidden) candidate += direction;
          if (candidate < 0 || candidate >= this.items.length) break;
          index = candidate;
          result = candidate;
        }
        return result;
      }

      open() {
        // pressed again while it is on its way out: it stays open
        if (this.closing) {
          this.closing.cancel();
          this.closing = null;
          this.trigger.setAttribute('aria-expanded', 'true');
          return;
        }
        if (this.isOpen || this.submitting) return;
        this.ensureItems();
        if (this.search) this.search.value = '';
        this.filter();
        const compactViewport = window.matchMedia('(max-width: 1023px)').matches;
        // The footer panel closes itself (a click outside moves focus
        // away, see focusout; Escape is handled here), so it can play its
        // way out before leaving the top layer - a browser light dismiss
        // would take it away at once.
        this.menu.setAttribute('popover', compactViewport || this.panel ? 'manual' : 'auto');
        this.menu.showPopover({ source: this.trigger });
        this.positionMenu();
        if (!this.isOpen) return;
        this.activate(Math.max(0, this.select.selectedIndex));
        if (this.search && !compactViewport) this.search.focus({ preventScroll: true });
        else this.list.focus({ preventScroll: true });
      }

      close(restoreFocus = true) {
        if (!this.isOpen || this.closing) return;
        if (restoreFocus) this.trigger.focus({ preventScroll: true });
        const panel = this.panel;
        if (!panel || typeof panel.animate !== 'function' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.menu.hidePopover();
          return;
        }
        // The way out: the panel sinks back toward its button, shrinking a
        // little as it fades, then leaves. Played here rather than as a CSS
        // exit transition, which Safari cuts short (it has no "overlay", so
        // the popover leaves the top layer at once).
        this.trigger.setAttribute('aria-expanded', 'false');
        const shift = this.dataset.localePlacement === 'bottom' ? -6 : 6;
        const closing = panel.animate([
          { opacity: 1, transform: 'none' },
          { opacity: 0, transform: `translateY(${shift}px) scale(.965)` }
        ], { duration: 200, easing: 'cubic-bezier(.4, 0, .8, .6)', fill: 'forwards' });
        this.closing = closing;
        closing.finished.then(() => {
          if (this.closing !== closing) return;
          this.closing = null;
          // already played out: leave at once, without the CSS exit
          // transition's second fade and its hold in the top layer
          this.menu.style.transition = 'none';
          if (this.menu.matches(':popover-open')) this.menu.hidePopover();
          closing.cancel();
          this.menu.offsetWidth;
          this.menu.style.removeProperty('transition');
        }, () => {});
      }

      get panel() {
        return this.menu?.querySelector('.premiere-locale__panel') || null;
      }

      positionMenu() {
        const rect = this.trigger.getBoundingClientRect();
        const viewport = window.visualViewport;
        const topEdge = (viewport?.offsetTop || 0) + 12;
        const leftEdge = (viewport?.offsetLeft || 0) + 12;
        const bottomEdge = topEdge + (viewport?.height || window.innerHeight) - 24;
        const rightEdge = leftEdge + (viewport?.width || document.documentElement.clientWidth) - 24;
        if (rect.bottom < topEdge || rect.top > bottomEdge) {
          if (!window.matchMedia('(max-width: 1023px)').matches) this.close(false);
          return;
        }
        const gap = 10;
        const above = Math.max(0, rect.top - topEdge - gap);
        const below = Math.max(0, bottomEdge - rect.bottom - gap);
        // The footer skin's panel (premiere-locale) adds a header row to the
        // search: count what the menu really holds around the list, so a
        // short list doesn't open towards a side with no room for the panel.
        const chrome = this.classList.contains('premiere-locale') ? Math.max(14, this.menu.offsetHeight - this.list.offsetHeight) : 14;
        const desiredHeight = Math.min(360 + chrome, this.list.scrollHeight + chrome);
        this.anchor = { rect, gap, above, below };
        this.upwards = below < desiredHeight && above > below;
        const width = Math.min(this.dataset.kind === 'language' ? 240 : 340, rightEdge - leftEdge);
        this.menu.style.width = `${width}px`;
        const rtl = getComputedStyle(this).direction === 'rtl';
        const alignedLeft = rtl ? rect.left : rect.right - width;
        this.menu.style.left = `${Math.max(leftEdge, Math.min(alignedLeft, rightEdge - width))}px`;
        this.reflowMenu();
      }

      reflowMenu() {
        if (!this.anchor) return;
        const { rect, gap, above, below } = this.anchor;
        const available = this.upwards ? above : below;
        this.menu.style.setProperty('--localization-menu-height', `${Math.max(0, Math.min(360, available - 14))}px`);
        const height = this.menu.getBoundingClientRect().height;
        this.menu.style.top = `${this.upwards ? rect.top - gap - height : rect.bottom + gap}px`;
      }

      activate(index) {
        this.activeIndex = index;
        this.items.forEach((item, i) => item.toggleAttribute('data-active', i === index));
        const item = this.items[index];
        if (!item) return;
        this.list.setAttribute('aria-activedescendant', item.id);
        const top = item.offsetTop;
        const bottom = top + item.offsetHeight;
        if (top < this.list.scrollTop) this.list.scrollTop = top;
        else if (bottom > this.list.scrollTop + this.list.clientHeight) this.list.scrollTop = bottom - this.list.clientHeight;
      }

      onKeyDown(event) {
        let index = this.activeIndex;
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          this.close();
          return;
        }
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.choose(index);
          return;
        }
        if (event.key === 'ArrowDown') index = this.nextVisible(index, 1);
        else if (event.key === 'ArrowUp') index = this.nextVisible(index, -1);
        else if (event.key === 'Home') index = this.nextVisible(-1, 1);
        else if (event.key === 'End') index = this.nextVisible(this.items.length, -1);
        else if (event.key === 'PageDown') index = this.nextVisible(index, 1, 8);
        else if (event.key === 'PageUp') index = this.nextVisible(index, -1, 8);
        else if (event.target === this.list && event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey && !event.isComposing) {
          const now = Date.now();
          this.searchText = now - (this.searchTime || 0) < 700 ? (this.searchText || '') + event.key : event.key;
          this.searchTime = now;
          let query = this.normalizeText(this.searchText);
          if (query.split('').every(char => char === query[0])) query = query[0];
          const start = query.length === 1 ? index + 1 : index;
          for (let offset = 0; offset < this.items.length; offset++) {
            const candidate = (start + offset) % this.items.length;
            if (this.items[candidate].hidden) continue;
            if (this.normalizeText(this.items[candidate].dataset.label || this.items[candidate].textContent).startsWith(query)) {
              index = candidate;
              break;
            }
          }
        } else return;
        event.preventDefault();
        this.activate(index);
      }

      choose(index) {
        if (this.submitting || !this.select.options[index] || this.select.options[index].disabled || this.items[index]?.hidden) return;
        if (this.select.selectedIndex === index) {
          this.close();
          return;
        }
        this.select.selectedIndex = index;
        const selectedValue = this.select.options[index].value;
        this.persistSelection(selectedValue);
        document.dispatchEvent(new CustomEvent('glass-localization:change', {
          detail: { kind: this.dataset.kind, value: selectedValue }
        }));
        this.close();
        const returnTo = this.form.querySelector('[name="return_to"]');
        if (returnTo) returnTo.value = window.location.pathname + window.location.search;
        this.submitting = true;
        this.trigger.setAttribute('aria-busy', 'true');
        try {
          HTMLFormElement.prototype.submit.call(this.form);
        } catch (error) {
          this.submitting = false;
          this.trigger.removeAttribute('aria-busy');
          throw error;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    // Apple-style: hovering the blurred backdrop closes the drawer, same as
  // the cart drawer. Gated on drawer:afterShow/afterHide so a cursor that's
  // already resting over the backdrop when the drawer starts opening can't
  // trigger an instant, mid-animation close.
  (function () {
    function init() {
      var menuDrawer = document.getElementById('MenuDrawer');
      var overlay = menuDrawer && menuDrawer.querySelector('.overlay');
      if (!menuDrawer || !overlay || overlay.dataset.hoverCloseBound) return;
      overlay.dataset.hoverCloseBound = 'true';

      var ready = false;
      var hoverCloseTimer = null;

      // The submenus come from the Section Rendering API and carry no
      // current-page state: when a level opens, its link to this page is
      // marked (and styled blue, like the top level).
      menuDrawer.addEventListener('toggle', function (event) {
        var details = event.target;
        if (!(details instanceof HTMLDetailsElement) || !details.open) return;
        details.querySelectorAll('.drawer__submenu a.drawer__menu-item[href]').forEach(function (link) {
          if (link.origin === location.origin && link.pathname === location.pathname) link.setAttribute('aria-current', 'page');
        });
      }, true);

      menuDrawer.addEventListener('drawer:afterShow', function () {
        ready = true;
      });

      menuDrawer.addEventListener('drawer:afterHide', function () {
        ready = false;
        if (hoverCloseTimer !== null) {
          clearTimeout(hoverCloseTimer);
          hoverCloseTimer = null;
        }
      });

      overlay.addEventListener('mouseenter', function () {
        if (!ready) return;
        if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
        if (menuDrawer.querySelector('.glass-localization__menu:popover-open')) return;
        hoverCloseTimer = setTimeout(function () {
          hoverCloseTimer = null;
          if (!ready) return;
          if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
          if (menuDrawer.querySelector('.glass-localization__menu:popover-open')) return;
          if (typeof menuDrawer.hide === 'function') {
            // Same ghost-click risk as tapping the backdrop directly
            // (onButtonClick in theme.js) - a touch device can synthesize
            // this same mouseenter close path, so it needs the same guard.
            if (typeof menuDrawer.guardAgainstGhostClick === 'function') menuDrawer.guardAgainstGhostClick();
            menuDrawer.hide();
          } else {
            overlay.click();
          }
        }, 100);
      });

      overlay.addEventListener('mouseleave', function () {
        if (hoverCloseTimer === null) return;
        clearTimeout(hoverCloseTimer);
        hoverCloseTimer = null;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hero-word-fade"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hero-word-fade')) {
    customElements.define('hero-word-fade', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.frame = requestAnimationFrame(() => this.prepare());
      }

      prepare() {
        if (this.initialized || !this.isConnected) return;
        this.initialized = true;
        this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
        if (this.motionPreference.matches || !this.animate || document.hidden || getComputedStyle(this).opacity !== '0') {
          this.finish();
          return;
        }

        this.animations = [];
        try {
          const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT, {
            acceptNode: node => node.parentElement.closest('svg, script, style, [aria-hidden="true"]')
              ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
          });
          const nodes = [];
          while (walker.nextNode()) nodes.push(walker.currentNode);
          const words = [];
          nodes.forEach(node => {
            const fragment = document.createDocumentFragment();
            node.textContent.split(/([\t\n\f\r ]+)/).forEach(text => {
              if (!text) return;
              if (/^[\t\n\f\r ]+$/.test(text)) {
                fragment.append(document.createTextNode(text));
              } else {
                const word = document.createElement('span');
                word.className = 'hero-word-fade__word';
                word.textContent = text;
                fragment.append(word);
                words.push(word);
              }
            });
            node.replaceWith(fragment);
          });

          this.onMotionChange = event => { if (event.matches) this.finish(); };
          this.onVisibilityChange = () => { if (document.hidden) this.finish(); };
          this.onPageShow = event => { if (event.persisted) this.finish(); };
          this.motionPreference.addEventListener('change', this.onMotionChange);
          document.addEventListener('visibilitychange', this.onVisibilityChange);
          window.addEventListener('pageshow', this.onPageShow);

          const step = Math.min(85, 260 / Math.max(1, words.length - 1));
          const startTime = document.timeline.currentTime;
          const finished = words.map((word, index) => {
            const animation = word.animate([
              { opacity: 0, transform: 'translateY(0.6em)' },
              { opacity: 1, transform: 'none' }
            ], {
              duration: 740,
              delay: index * step,
              easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
              fill: 'both'
            });
            this.animations.push(animation);
            const result = animation.finished.catch(() => {});
            if (startTime !== null) animation.startTime = startTime;
            return result;
          });
          this.setAttribute('data-ready', '');
          Promise.all(finished).then(() => this.finish());
        } catch {
          this.finish();
        }
      }

      finish() {
        if (this.completed) return;
        this.completed = true;
        this.setAttribute('data-ready', '');
        this.animations?.forEach(animation => animation.cancel());
        this.animations = [];
        this.motionPreference?.removeEventListener('change', this.onMotionChange);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        window.removeEventListener('pageshow', this.onPageShow);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.initialized) this.finish();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
